var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMasterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.429 17.3288C16.2449 18.3268 14.709 18.9293 13.0307 18.9293C9.28582 18.9293 6.25 15.9296 6.25 12.2293C6.25 8.52899 9.28582 5.5293 13.0307 5.5293C14.709 5.5293 16.2449 6.13179 17.429 7.12984C18.613 6.13179 20.1489 5.5293 21.8273 5.5293C25.5721 5.5293 28.608 8.52899 28.608 12.2293C28.608 15.9296 25.5721 18.9293 21.8273 18.9293C20.1489 18.9293 18.613 18.3268 17.429 17.3288Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4292 17.3288C18.8871 16.0999 19.8116 14.2713 19.8116 12.2293C19.8116 10.1873 18.8871 8.35874 17.4292 7.12984C18.6132 6.13179 20.1492 5.5293 21.8275 5.5293C25.5724 5.5293 28.6082 8.52899 28.6082 12.2293C28.6082 15.9296 25.5724 18.9293 21.8275 18.9293C20.1492 18.9293 18.6132 18.3268 17.4292 17.3288Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4288 17.3278C18.8867 16.0989 19.8111 14.2703 19.8111 12.2283C19.8111 10.1864 18.8867 8.35781 17.4288 7.12891C15.9708 8.35781 15.0464 10.1864 15.0464 12.2283C15.0464 14.2703 15.9708 16.0989 17.4288 17.3278Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMasterIcon);
export default __webpack_public_path__ + "static/media/Payment-master-icon.6605ddeb227a6556b3e49708bc6fe126.svg";
export { ForwardRef as ReactComponent };